import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { concat, of, ReplaySubject, Subject } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { LclPortModel } from '@data-layer/models/lcl';
import { CodeRepository } from '@data-layer/repositories';
import { catchError, debounceTime, distinctUntilChanged, switchMap, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'lcl-port-dropdown',
  templateUrl: './lcl-port-dropdown.component.html',
  styleUrls: ['./lcl-port-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclPortDropdownComponent implements OnInit, OnDestroy {
  @Input() public fc: UntypedFormControl;
  @Input() public fcName: string;
  @Input() public title: string;
  @Input() public isExternal: boolean;
  @Input() public isSubmitted: boolean;

  @Output() public selectPort: EventEmitter<LclPortModel> = new EventEmitter<LclPortModel>();
  @Output() public onSearch: EventEmitter<void> = new EventEmitter<void>();
  @Output() public onClear: EventEmitter<void> = new EventEmitter<void>();

  public ports: LclPortModel[] = [];
  public portsLoading: boolean = false;
  public portsInput$: Subject<string> = new Subject<string>();

  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(private codeRepository: CodeRepository, private cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.fc.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((id: number) => {
      const port: LclPortModel = (this.ports || []).find((item: LclPortModel) => item.id === id);
      if (!!port) {
        this.selectPort.emit(port);
      }
    });

    this.loadPorts();
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  private loadPorts(): void {
    concat(
      of([]),
      this.portsInput$.pipe(
        distinctUntilChanged(),
        debounceTime(300),
        tap(() => (this.portsLoading = true)),
        switchMap((term: string) =>
          this.codeRepository.searchFreightPortV2(term).pipe(
            catchError(() => of([])),
            tap(() => (this.portsLoading = false)),
          ),
        ),
        takeUntil(this.destroy$),
      ),
    ).subscribe((ports: LclPortModel[]) => {
      this.ports = ports;
      this.cdr.markForCheck();
    });
  }
}
